import Spinner from "react-bootstrap/Spinner";

const LoadingSpinner = () => {
  return (
    <div className="d-flex justify-content-center">
      <Spinner animation="border" variant="secondary" />
    </div>
  );
};

export default LoadingSpinner;
